module.exports = __webpack_public_path__ + "static/img/nodata.dfa3619d.svg";